export const CIM_STATUS_KEYS = [
  'DRAFT',
  'ISSUED',
  'SIGNED',
  'IN_TRANSIT',
  'DELIVERED',
  'CANCELLED',
  'AMENDED',
] as const

export const CIM_STATUS_CLASS: Record<string, string> = {
  DRAFT: 'text-muted-foreground',
  ISSUED: 'text-blue-600',
  SIGNED: 'text-indigo-600',
  IN_TRANSIT: 'text-orange-600',
  DELIVERED: 'text-green-600',
  CANCELLED: 'text-red-600',
  AMENDED: 'text-yellow-600',
}

export const CIM_WAYBILL_TYPE_KEYS = ['CIM', 'CIM_SMGS', 'ECIM'] as const
